var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrowdstrike = function SvgCrowdstrike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "crowdstrike_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 293.3 52"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".crowdstrike_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#fc0000}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crowdstrike_svg__Homepage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crowdstrike_svg__Home",
    transform: "translate(-72 -7240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crowdstrike_svg__Group-24",
    transform: "translate(72 7240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crowdstrike_svg__Group-7",
    transform: "translate(13 3.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-1",
    d: "M33.9 21.6v-.5l-4.4-3.8H29c-1.2 1.3-3.1 2.4-5.2 2.4-3.3 0-5.9-2.5-5.9-5.9s2.6-5.9 5.9-5.9c2.1 0 4 1 5.2 2.4h.5l4.4-3.8v-.7c-2.3-2.8-6-4.7-10.1-4.7-7.6 0-13.4 5.4-13.4 12.6 0 .3.1.5.1.8 3.1 2.1 5.9 3.8 8.2 5.4 3.4 2.2 6.2 4.1 8.4 6 2.9-.7 5.1-2.3 6.8-4.3m-20.7-.1c1.8 2.2 4.3 3.7 7.2 4.4-2-1.1-3.9-2.2-5.7-3.4-.5-.4-1-.7-1.5-1",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-3",
    d: "m59.5 24.7-1.1-4.8-.4-.2c-.2.1-.4.3-1 .3-.9 0-1.4-.9-1.8-1.6-.7-1.1-1.3-1.7-1.8-2 2.7-1.2 4.5-3.4 4.5-6.7 0-5-3.4-8.1-9.7-8.1h-11v24.3h7.3v-8.5h.7c1.6 0 3.7 3.5 4.7 5.1 2 3.2 3.6 3.9 6.4 3.9 1.3 0 2.4-.5 3.1-1.1zm-9.1-14.6c0 1.6-1.2 2.4-2.5 2.4h-3.4v-5h3.4c1.4 0 2.5.9 2.5 2.6",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-5",
    d: "M87.7 13.7c0-7.2-5.8-12.6-13.4-12.6S61 6.5 61 13.7s5.8 12.6 13.4 12.6 13.3-5.4 13.3-12.6m-7.4 0c0 3.5-2.7 5.9-5.9 5.9-3.3 0-5.9-2.5-5.9-5.9s2.7-5.9 5.9-5.9 5.9 2.4 5.9 5.9",
    className: "crowdstrike_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-8",
    d: "M137.3 5.1h-7L126 18.5l-4.6-13.4H117l-4.5 13.4-4.3-13.4h-7l-.3.6 8.9 23.7h4.4l5-13.2 5.1 13.2h4.4l8.9-23.7z",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-9",
    d: "M164.4 17.2c0-7.2-4.8-12.1-12.7-12.1h-11.2v24.3h11.2c7.9 0 12.7-4.9 12.7-12.2m-7.5 0c0 4-2.3 6.2-5.5 6.2h-3.6V11.1h3.6c3.2 0 5.5 2.2 5.5 6.1",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-11",
    d: "M203.1 11.1h7.3v-6h-21.9v6h7.3v18.3h7.3z",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-12",
    d: "M233.8 13.2c0-5-3.4-8.1-9.7-8.1h-11v24.3h7.3v-8.5h1.7l4.5 8.5h7.3l.3-.6-4.9-9c2.7-1.2 4.5-3.4 4.5-6.6m-7.5.4c0 1.6-1.2 2.4-2.5 2.4h-3.4v-4.9h3.4c1.3 0 2.5.9 2.5 2.5",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-14",
    d: "M238.2 29.4h7.3V5.1h-7.3z",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-15",
    d: "m264 16 8.3-10.3-.3-.6h-7.8l-6.8 8.6V5.1h-7.3v24.3h7.3v-7.5l1.3-1.6 6.2 9.1h7.7l.3-.6z",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-16",
    d: "M274.9 5.1v24.3h18.4v-6h-11.1V20h8.4v-5.6h-8.4v-3.3h11v-6z",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "crowdstrike_svg__Group-23",
    transform: "translate(0 .527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-17",
    d: "M176.8 29.1c5.4 0 10-2.6 10-7.7 0-5.5-4.7-6.9-8.8-8.1-1.6-.5-3.3-1-3.3-2.2 0-.9.9-1.4 2.3-1.4 2.4 0 4.4 1.5 5.5 2.5h.5l3.4-4.1v-.5c-1.8-2.1-5.5-3.6-9.6-3.6-5.7 0-9.6 3.1-9.6 7.5 0 4.8 4.4 6.9 8 7.9 2.4.7 4 .8 4 2.1 0 .9-1.1 1.5-2.9 1.5-2.3 0-5-1.5-6.3-2.8h-.5l-3.4 4.3v.5c2.2 2.4 6.1 4.1 10.7 4.1",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-19",
    d: "M50.8 51.5c-1.8-4.1-5.3-9.2-19.3-16.7-6.4-3.6-17.4-9.1-27.3-19.5.9 3.8 5.5 12.1 25.2 22.4 5.5 3 14.8 5.8 21.4 13.8",
    className: "crowdstrike_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crowdstrike_svg__Fill-21",
    d: "M49.9 44.5c-1.7-4.8-4.7-10.9-19.1-20-7-4.6-17.3-10.4-30.8-25 1 4 5.2 14.3 26.8 27.6 7.1 4.8 16.2 7.8 23.1 17.4",
    className: "crowdstrike_svg__st0"
  })))))));
};
export default SvgCrowdstrike;